module.exports = __webpack_public_path__ + "img/appeal_status_icon_green.5915a8ad.svg";